import React from "react";

export default {
    name: 'about',
    type: 'document',
    title: 'About',
    fields: [
        {
            name: 'title',
            type: 'string',
            title: 'Title',
            readOnly: true,
            hidden: true,
        },
        {
            name: 'slug',
            type: 'slug',
            title: 'Slug',
            readOnly: true,
            hidden: true,
        },

        {
            title: 'About',
            name: 'content',
            type: 'array',
            // options: {
            //     layout: 'checkbox',
            // },
            of: [
                {
                    type: "object",
                    name: "item",
                    title: "Block",
                    fields: [
                        {
                            title: 'Type',
                            name: 'type',
                            type: 'string',
                            options: {
                                list: [
                                    { title: 'Text', value: 'text' },
                                    { title: 'Image(s)', value: 'image' },
                                ],
                                layout: 'radio'
                            },
                            initialValue: 'text',
                        },

                        {
                            name: 'text',
                            title: 'Text',
                            type: "array",
                            of: [{
                                type: "block",
                                styles: [],
                                // lists: [],
                                marks: {
                                    decorators: [
                                        { title: 'Italic', value: "em" },
                                    ],
                                    annotations: [],
                                },

                            }],
                            hidden: ({ parent, value }) => parent?.type != 'text',
                        },
                        {
                            title: 'Images',
                            name: 'images',
                            type: 'array',
                            options: {
                                layout: 'grid',
                            },
                            hidden: ({ parent, value }) => parent?.type != 'image',
                            of: [
                                {
                                    title: 'Image',
                                    name: 'image',
                                    type: 'image',
                                }
                            ],
                        }
                    ],
                    preview: {
                        select: {
                            // id: "id",
                            type: "type",
                            text: "text",
                            images: "images"
                        },
                        prepare({ type = "", text, images }) {
                            return type == 'image' ? {
                                media: () => (<img src={type == 'image' && images ? 'https://cdn.sanity.io/images/0lkrnbuy/production/' + images[0].asset?._ref.replace(/image-/g, '').replace(/-([jpengtifwb]+)$/g, '.$1') : ''
                                } style={{ 'object-fit': 'cover' }
                                } />),
                                title: `${images.length} Image${images.length > 1 ? 's' : ''}`
                            } : {
                                title: text ? toPlainText(text) : false,
                            };
                        },
                    },
                }
            ],
        },
    ]
}

function toPlainText(blocks = []) {
    return blocks
        // loop through each block
        .map(block => {
            // if it's not a text block with children, 
            // return nothing
            if (block._type !== 'block' || !block.children) {
                return ''
            }
            // loop through the children spans, and join the
            // text strings
            return block.children.map(child => child.text).join('')
        })
        // join the paragraphs leaving split by two linebreaks
        .join('\n\n')
}


// WEBPACK FOOTER //
// ./schemas/about.js